import { Filter } from '@ais-ui/websockets';
import { FilterType } from '../../reportsTypes';
import { ReportFilterType } from '../../utils';

export function createFilter(
  zedData: any,
  filters: Filter[],
  filterType: FilterType
): ReportFilterType | null {
  if (filterType === 'combined') {
    let selectedFilter = null;
    if (zedData?.filter) {
      for (const filter of filters) {
        if (filter.uuid === zedData.filter) {
          selectedFilter = filter;
          break;
        }
      }
    }
    let shiplist = '';
    if (zedData?.shiplist) {
      shiplist = zedData.shiplist;
    }
    return {
      shiplist: shiplist,
      filter: selectedFilter,
    };
  }

  if (filterType === 'normal') {
    for (const filter of filters) {
      if (filter.uuid === zedData.filter) {
        return filter;
      }
    }
    if (zedData.filter === 'no-filter' || !zedData.filter) {
      return null;
    }
  } else if (filterType === 'ship') {
    return zedData.filter;
  } else if (filterType === 'shiplist') {
    return zedData.filter;
  }

  return null;
}
